// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-o97","footer":"styles_footer__3q3WF"};